(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('HistoricoUsosMaquinasCtrl', HistoricoUsosMaquinasController);

  HistoricoUsosMaquinasController.$inject = [
    '$scope',
    '$routeParams',
    'LoadingService',
    'UsoMaquinasService',
    'MessagesService',
    '$route',
    'PeriodSelectService',
    'OperacoesService',
    '$q',
    'MaquinasService',
    '$filter',
    'DrawPolygonsService',
    'MapaService',
    'LeafletService',
    'TrackingService',
    'DrawPolygonsObjectService',
    'OperacoesDadosService',
    '$http',
    '$anchorScroll'
  ];
  // eslint-disable-next-line max-lines-per-function, max-params
  function HistoricoUsosMaquinasController($scope, $routeParams, LoadingService,
    UsoMaquinasService, MessagesService, $route,
    PeriodSelectService, OperacoesService, $q,
    MaquinasService, $filter, DrawPolygonsService,
    MapaService, LeafletService, TrackingService,
    DrawPolygonsObjectService, OperacoesDadosService, $http, $anchorScroll) {
    const vm = this;
    let hasNextPage = true;
    let inProgress = false;

    //////////////////////////////////////////
    // Controller data
    vm.filters = {
      gleba: null,
      operacao: null,
      maquina: null,
      dataInicial: null,
      dataFinal: null,
      page: 1
    };
    vm.filtroPeriodo = null;
    vm.period = {
      eventDates: [],
      periodo: ''
    };
    vm.glebas = [];
    vm.operacoes = [];
    vm.maquinas = [];
    vm.loading = true;
    vm.usosMaquinas = [];
    vm.reseting = false;

    //////////////////////////////////////////
    // Bindable methods
    vm.setFilterAttribute = setFilterAttribute;
    vm.isDifferentDate = isDifferentDate;
    vm.textDayLabel = textDayLabel;
    vm.setPeriodo = setPeriodo;
    vm.openPeriodsFilter = openPeriodsFilter;
    vm.showRastro = showRastro;
    vm.getUsoMaquinas = getUsoMaquinas;
    vm.getUsoCardId = getUsoCardId;

    //////////////////////////////////////////
    // Function declarations

    function reset() {
      vm.reseting = true;
      vm.glebas = $scope.$root.currentPropriedade.glebas || [];
      vm.usosMaquinas = [];
      vm.filtroPeriodo = PeriodSelectService.getFilterPeriodo($scope.$root.safras);
      for (const key in vm.filters) {
        vm.filters[key] = null;
      }

      vm.filters.page = 1;

      setPeriodo(vm.filtroPeriodo[0]);
      vm.reseting = false;
    }

    function setFilterAttribute(attribute, value) {
      vm.filters[attribute] = value;
      initializeVariables();
      return load();
    }

    function getUsoMaquinas() {
      if (hasNextPage && !inProgress) {
        inProgress = true;
        load();
      }
    }

    function initializeVariables() {
      vm.usosMaquinas = [];
      hasNextPage = true;
      inProgress = false;
      vm.filters.page = 1;
    }

    function load() {
      const { gleba, operacao, maquina, dataInicial, dataFinal, page } = vm.filters;
      vm.loading = true;
      return UsoMaquinasService.load({
        gleba: (gleba || {}).id,
        operacao: (operacao || {}).id,
        maquina_id: (maquina || {}).id,
        data_inicial: dataInicial,
        data_final: dataFinal,
        page: page
      })
        .then(({ data, pages }) => {
          hasNextPage = _.get(pages, 'pagination.next', 0) > vm.filters.page;
          if (data.length) {
            vm.filters.page++;

            vm.usosMaquinas = vm.usosMaquinas.concat(
              _.chain(data)
                .map(formatImagesObj)
                .orderBy('id', 'desc')
                .map(organizeData)
                .value()
            );
          }
          abrirUsoMaquinaAlvo();
        })
        .finally(() => {
          inProgress = false;
          vm.loading = false;
        });
    }

    function getUsoCardId(uso) {
      return `uso-maquina-${uso.id}`;
    }

    function abrirUsoMaquinaAlvo() {
      if (!$routeParams.activeUsoMaquina) {
        return;
      }
      const alvo = vm.usosMaquinas.find((uso) => +uso.id === +$routeParams.activeUsoMaquina);
      if (alvo && !alvo.open) {
        alvo.open = true;
        $anchorScroll(getUsoCardId(alvo));
      }
    }

    function formatImagesObj(uso) {
      if (uso.imagens.length > 0) {
        uso.imagens = OperacoesDadosService.getImagesObject(uso.imagens);
      }

      return uso;
    }

    function organizeData(uso) {
      uso.organizedData = {
        Código: uso.id,
        'Criada por': uso.usuario.nome,
        Máquina: uso.maquina.descricao,
        Talhão: (uso.gleba || {}).descricao,
        Início: getDate(uso.dt_inicial_ps, uso.hora_inicial_tempo),
        Término: getDate(uso.dt_final_ps, uso.hora_final_tempo),
        Operação: uso.operacao.descricao,
        Operador: uso.operador.nome,
        Consumo: +uso.consumo_combustivel > 0 ? `${$filter('number')(uso.consumo_combustivel)} L` : 'Não informado',
        'Horímetro Inicial': +uso.hora_inicial_mec,
        'Horímetro Final': +uso.hora_final_mec,
        Partida: uso.partida,
        Destino: uso.destino,
        Observações: uso.obs
      };

      if (+uso.qt_area) {
        uso.organizedData['Área total'] = `${+uso.qt_area} ha`;
      }
      return uso;
    }

    function getDate(date, time) {
      const format = 'DD/MM';
      if (!time || date.length > 10) {
        return moment(date).format(format);
      }
      return moment(`${date} ${time}`).format(`${format} HH:mm`);
    }

    function isDifferentDate({ data }, index) {
      return index === 0 || data !== vm.usosMaquinas[index - 1].data;
    }

    function textDayLabel({ data }) {
      return moment(data).format('DD [de] MMMM');
    }

    function setPeriodo(periodo) {
      if (periodo) {
        vm.filters.dataInicial = periodo.dataInicial;
        vm.filters.dataFinal = periodo.dataFinal;
        vm.period.periodo = periodo.descricao;
      }
      if (!vm.reseting) {
        initializeVariables();
        load();
      }
    }

    function openPeriodsFilter() {
      PeriodSelectService.openPeriodSelection(vm.period, vm.filters).then(function() {
        setPeriodo();
      });
    }

    function loadRastroByTracking(uso) {
      LoadingService.showLoading();
      $scope.$emit('clearHeatMap');
      $http.get(`${ SERVER }v1/prestacao_servicos/${uso.id}/tracking`)
        .then(function(response) {
          const data = response.data;

          if (data.length > 0) {
            uso.hasNoCoordinatesData = false;

            const polylines = MapaService.getLeafletPolylineWithObject({
              pontos: data,
              faixas: uso.faixas_velocidade
            });

            uso.rastro = { polygons: polylines };

            processLoadedPolygons(uso);
            const start = uso.rastro.polygons[0].coordinate;
            const end = uso.rastro.polygons[uso.rastro.polygons.length - 1].coordinate;
            uso.startEndMarkers = MapaService.createStartEndMarkers(start, end);

            renderPolylines(uso);
          } else {
            uso.hasNoCoordinatesData = true;
          }
        })
        .finally(LoadingService.hideLoading);
    }

    function showRastro(uso) {
      if (uso.viewingRastro) {
        $scope.$emit('setActiveHeatmaps', []);
        clearMap();
        return hideRastro(uso);
      }

      hideAllRastros();

      if (!uso.rastro) {
        if (uso.area_demarcada_id) {
          $scope.$emit('setActiveHeatmaps', { heatmaps: [uso], mapType: 'machine' });
          return loadRastro(uso)
            .then(() => renderPolylines(uso));
        }

        return loadRastroByTracking(uso);
      }
      renderPolylines(uso);
    }

    function hideAllRastros() {
      vm.usosMaquinas
        .filter((uso) => uso.viewingRastro)
        .forEach(hideRastro);
    }

    function loadRastro(uso) {
      const { area_demarcada_id: areaId } = uso;
      LoadingService.showLoading();
      uso.rastro = {};
      return DrawPolygonsService.get(areaId)
        .then(({ data }) => {
          const polylines = MapaService.getLeafletPolylineWithObject({
            pontos: _.flatMap(data.coordenadas, 'pontos'),
            faixas: data.faixas_velocidade
          });

          uso.rastro = { polygons: polylines };
          const start = uso.rastro.polygons[0].coordinate;
          const end = uso.rastro.polygons[uso.rastro.polygons.length - 1].coordinate;

          uso.startEndMarkers = MapaService.createStartEndMarkers(start, end);
        })
        .catch((error) => {
          console.error(error);
          MessagesService.alert('Erro ao obter rastro da máquina.');
          uso.rastro = [];
        })
        .finally(LoadingService.hideLoading);
    }

    function processLoadedPolygons(uso) {
      uso.rastro.polygons.forEach((polygon) => {
        polygon.descricao = formatDescricaoHtml(uso);

        if (polygon.coordinate) {
          addPolygonPopup(polygon);
        }
      });
    }

    function formatDescricaoHtml(uso) {
      const descricao = [];

      if (uso.gleba) {
        descricao.push(uso.gleba.descricao);
      }

      descricao.push(uso.descricao);

      if (uso.rastro.atividade) {
        descricao.push(`Cultura: ${uso.rastro.atividade.descricao}`);
      }

      if (uso.rastro.cultivar) {
        descricao.push(`Cultivar: ${uso.rastro.cultivar.descricao}`);
      }

      return descricao.join('<br>');
    }

    function addPolygonPopup(polygon) {
      const popup = L.popup();
      polygon.bindPopup(popup);
      polygon.on('popupopen', () => {
        popup.setContent(createInfoWindow(polygon));
      });
    }

    function renderPolylines(uso) {
      uso.viewingRastro = true;
      $scope.$emit('setPolylines', uso.rastro.polygons);
      $scope.$emit('setMarkers', uso.startEndMarkers);
      const map = LeafletService.getMap('propriedade-map');

      map.fitBounds(uso.rastro.polygons.map(function(polyline) {
        return polyline.getBounds();
      }));

      uso.rastro.polygons.forEach((polyline) => polyline.bindPopup(createInfoWindow(polyline)));
    }

    function createInfoWindow(polygon) {
      const content = TrackingService.getContentInfoWindow(polygon);
      return `<div class="simple-popup">
                ${content}
              </div>`;
    }

    function hideRastro(uso) {
      uso.viewingRastro = false;
      $scope.$emit('clearPolylines');
      $scope.$emit('clearMarkers');
    }

    function clearMap() {
      $scope.$emit('setImageOverlays', []);
      $scope.$emit('setActiveHeatmaps', []);

      setTimeout(() => {
        $route.updateParams({
          heatmaps: null
        });
      }, 0);
    }
    //////////////////////////////////////////
    // Controller logic

    $scope.$root.initialize
      .then(() => {
        if (!$scope.$root.permissions.usosMaquinas.canRead) {
          MessagesService.alert(ACESSO_NAO_PERMITIDO.msg);
          return $route.updateParams({
            sidebar: null
          });
        }
        LoadingService.showLoading();
        reset();
        clearMap();

        const selectedGleba = $routeParams.gleba || $routeParams.activeGleba;
        if (selectedGleba) {
          const glebas = $scope.$root.currentPropriedade.glebas;
          setFilterAttribute('gleba', glebas.find((gleba) => gleba.id === +selectedGleba));
        }

        return $q.all([
          OperacoesService.getTipoOperacoesTodas(),
          MaquinasService.list()
        ]).then(([operacoes, maquinas]) => {
          vm.operacoes = operacoes.data;
          vm.maquinas = maquinas.data;
        });
      })
      .catch((error) => {
        console.error(error);
        MessagesService.alert('Erro ao carregar usos de máquinas.');
        vm.loading = false;
      })
      .finally(LoadingService.hideLoading);
  }
}());
